module.exports = __webpack_public_path__ + "img/Mask Group 7.eae0f7f9.png";